import { TimeoutError } from '../misc/errorTypes';

async function sleep (wait) {
  return new Promise(resolve => {
    setTimeout(resolve, wait);
  });
}

export function withTimeout (promise, timeout) {
  return Promise.race([
    sleep(timeout).then(() => {
      throw new TimeoutError();
    }),
    promise,
  ]);
}

export function tryRequest (requestHandler, { times = [0, 3000, 5000] } = {}) {
  async function waitAndTry () {
    const wait = times.shift();
    await sleep(wait);
    return requestHandler(waitAndTry, { remaining: times.length });
  }
  return waitAndTry();
}
